// The development address has two forms, and which one is right depends on the
// runtime rather than the environment.
//
// Ordinarily both the browser and the server reach GraphQL at the internal
// localhost address, because the browser is on the same machine.
//
// A candidate workspace breaks that assumption. The browser is somebody else's,
// on the far side of a tunnel, so `localhost:4000` there is their own machine.
// In candidate mode the browser therefore uses a relative path, which the local
// proxy routes to GraphQL, while server rendering keeps the internal address.
//
// This has to be lazy. Two of the three consumers build their Apollo link at
// module scope, and the module is evaluated separately in each runtime, so a
// getter resolves correctly in both. Reading it eagerly here would bake the
// server's answer into the browser bundle.
export const internalDevelopmentEndpoint = () =>
  process.env.GRAPHQL_ENDPOINT ||
  `http://${process.env.LOCALHOST || 'localhost'}:${
    process.env.GRAPHQL_PORT || '4000'
  }/development/graphql`

// The proxy routes this path to GraphQL and everything else to Next.
export const CANDIDATE_BROWSER_GRAPHQL_PATH = '/development/graphql'

export const isCandidateMode = () => process.env.KICKOFF_CANDIDATE_MODE === '1'

export const developmentEndpoint = () => {
  if (!isCandidateMode()) return internalDevelopmentEndpoint()
  return typeof window === 'undefined'
    ? internalDevelopmentEndpoint()
    : CANDIDATE_BROWSER_GRAPHQL_PATH
}

export const ENVIRONMENT_ENDPOINTS = {
  production:
    'https://v82hc6meb4.execute-api.us-west-1.amazonaws.com/production/graphql/',
  beta: 'https://797zeqguwl.execute-api.us-west-1.amazonaws.com/beta/graphql/',
  staging:
    'https://kr82977pc4.execute-api.us-west-1.amazonaws.com/staging/graphql/',
  growth:
    'https://1sbu7pf2oj.execute-api.us-west-1.amazonaws.com/growth/graphql/',
  get development() {
    return developmentEndpoint()
  },
}
